"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../constants");

var _utils = require("../../utils");

var _Section = _interopRequireDefault(require("./Section"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    logoContainer: {
      padding: theme.spacing(3)
    },
    sideBar: {
      overflowY: "scroll",
      background: theme.palette.background.default,
      boxShadow: theme.shadows[3]
    },
    image: {
      textAlign: "center",
      filter: "grayscale(100%)",
      opacity: .6,
      transition: "all 2s",
      "&:hover": {
        filter: 'grayscale(10%)'
      }
    },
    title: {
      textAlign: "center",
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2)
    },
    footer: {
      textAlign: "center",
      padding: theme.spacing(2),
      marginTop: theme.spacing(5)
    },
    link: {
      textAlign: "center",
      fontSize: 9
    }
  };
});
/**
 * Story SideBar component.
 */

function SideBar(props) {
  var activeIndex = props.activeIndex,
      children = props.children,
      description = props.description,
      image = props.image,
      type = props.type,
      onSelect = props.onSelect,
      logo = props.logo,
      title = props.title;
  var classes = useStyles();

  var renderSections = function renderSections() {
    return _react.default.Children.map(children, function (moment) {
      var _moment$props = moment.props,
          color = _moment$props.color,
          icon = _moment$props.icon,
          index = _moment$props.index,
          label = _moment$props.label;
      var sectionProps = {
        icon: icon,
        index: index,
        isActive: activeIndex == index,
        onClick: onSelect,
        text: label
      };

      if (color) {
        sectionProps.accentColor = color.background;
        sectionProps.textColor = color.text;
      }

      return _react.default.createElement(_Section.default, sectionProps);
    });
  };

  var containerClasses = (0, _utils.classList)(classes.sideBar, 'story-sidebar', "story-sidebar-".concat(type));
  return _react.default.createElement("div", {
    className: containerClasses
  }, logo && _react.default.createElement("div", {
    className: classes.logoContainer
  }, logo), (title || description) && _react.default.createElement("div", {
    className: classes.title
  }, _react.default.createElement(_core.Typography, {
    color: "primary",
    variant: "overline"
  }, title, _react.default.createElement(_core.Divider, null)), _react.default.createElement(_core.Typography, {
    color: "textSecondary",
    variant: "caption"
  }, description)), image && _react.default.createElement(_core.CardMedia, {
    className: classes.image,
    component: "img",
    image: image,
    title: "image of ".concat(title)
  }), renderSections(), _react.default.createElement("div", {
    className: classes.footer
  }, _react.default.createElement(_core.Button, {
    className: classes.link,
    target: "_blank",
    color: "secondary",
    href: _constants.STORIES_API_HOMEPAGE
  }, "POWERED BY THE STORIES SERVICE")));
}

;
SideBar.propTypes = {
  activeIndex: _propTypes.default.any,

  /** List of `Moment`s to render information from */
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  logo: _propTypes.default.any,
  onSelect: _propTypes.default.func,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  image: _propTypes.default.string
};
SideBar.defaultProps = {
  onSelect: function onSelect() {}
};
var _default = SideBar;
exports.default = _default;